module.exports = __webpack_public_path__ + "static/img/02560_7.b63254c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/02560_7.jpg
// module id = q929
// module chunks = 1